import { IFormErrors } from '@interfaces/IFormsErrors';
import { Action } from '@ngrx/store';
import { ICard } from '@interfaces/IAccountants';

export enum EAccountantsViewActions {
  GetCardsRequest = '[Accountants-view] Get Cards Request',
  GetCardsSuccess = 'Accountants-view] Get Cards Success',
  GetCardsFailure = '[Accountants-view] Get Cards Failure',
  ClearGetCards = '[Accountants-view] Clear Get Cards',
}

export class GetCardsRequest implements Action {
  public readonly type = EAccountantsViewActions.GetCardsRequest;
}

export class GetCardsSuccess implements Action {
  public readonly type = EAccountantsViewActions.GetCardsSuccess;

  constructor(public data: ICard[]) {}
}

export class GetCardsFailure implements Action {
  public readonly type = EAccountantsViewActions.GetCardsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetCards implements Action {
  public readonly type = EAccountantsViewActions.ClearGetCards;
}

export type AccountantsViewActions =
  | GetCardsRequest
  | GetCardsSuccess
  | GetCardsFailure
  | ClearGetCards;
